import {atom} from 'recoil';

import {Features} from '@lexian/api/support-api';

export const featureFlagState = atom<Features>({
  key: 'featureFlagState',
  default: {
    advancePaymentRequest: false,
    allEmails: false,
    clientMoney: false,
    clientSidePdfGeneration: false,
    digitalSigning: false,
    globalTasks: false,
    justitia: false,
    notes: false,
    invoiceAmendment: false,
    timeTracker: false,
  },
});
